import { Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import Heading from "../../AdminComponents/Common/Heading";
import TextInput from "../../Components/Common/TextInput";
import CustomButton from "../../Components/Common/CustomButton";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Dropdown from "../../AdminComponents/Common/Dropdown";
import { BASE_URL } from "../../Assets/Constants";
import { category } from "../../Services/dymmyData";
import { toast } from "react-toastify";

function TicketCreation() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { type } = useParams();
  const [inputValues, setInputValues] = useState({
    name: "",
    type: "",
    experience: "",
  });

  const [adventureOptions, setAdventureOptions] = useState([]);
  const [errors, setErrors] = useState([]);
  const [generalError, setGeneralError] = useState("");
  const [loading, setLoading] = useState(false);

  console.log(errors, "ERRORS");
  

  useEffect(() => {
    const fetchAdventures = async () => {
      const loginData = JSON.parse(localStorage.getItem("adminData"));
      const token = loginData?.token;

      if (!token) {
        toast.error("Authentication token is missing", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        navigate('/login')
        return;
      }

      try {
        const response = await axios.get(`${BASE_URL}/admin/experiences`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const adventures = response?.data?.data;

        if (!Array.isArray(adventures)) {
          throw new Error("Unexpected data format: adventures is not an array");
        }

        const types = adventures.map((item) => ({
          value: item?._id,
          label: item?.name,
        }));

        const uniqueTypes = types?.filter(
          (type, index, self) =>
            index === self.findIndex((t) => t.label === type?.label)
        );
        setAdventureOptions(types);
      } catch (error) {
        console.error("Error fetching adventure options:", error.message);
      }
    };

    fetchAdventures();
  }, []);

  useEffect(() => {
    setInputValues((prev) => ({
      ...prev,
      name: state?.name || "",
    }));
  }, [state]);

  const handleAddBarcode = async () => {
    setErrors([]);
    const loginData = JSON.parse(localStorage.getItem("adminData"));
    const token = loginData?.token;

    if (!token) {
      toast.error("Authentication token is missing", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      navigate('/login')
      return;
    }

    const payload = {
      name: inputValues.name,
    };

    setLoading(true)

    try {
      const response = await axios.post(
        `${BASE_URL}/admin/ticket`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Ticket created successfully", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        style: { backgroundColor: 'orange', color: 'white' },
      });
      navigate(-1);
    } catch (error) {
      console.error("Error storing ticket:", error?.response?.data);
      setErrors(error?.response?.data?.errors || []);
      setGeneralError(error?.response?.data?.error);
    }
    finally {
      setLoading(false)
    }
  };

  const handleUpdateBarcode = async () => {
    setErrors([]);
    const loginData = JSON.parse(localStorage.getItem("adminData"));
    const token = loginData?.token;

    if (!token) {
      toast.error("Authentication token is missing", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      navigate('/login')
      return;
    }

    const payload = {
      name: inputValues.name,
    };

    setLoading(true)
    try {
      const response = await axios.put(
        `${BASE_URL}/admin/ticket/${state?._id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Ticket updated successfully", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        style: { backgroundColor: 'orange', color: 'white' },
      });

      navigate(-1);
    } catch (error) {
      console.error("Error updating ticket:", error?.response?.data?.errors);
      setGeneralError(error?.response?.data?.error);
      setErrors(error?.response?.data?.errors || []);
    } finally {
      setLoading(false)
    }
  };

  const getErrorMessage = (field) => {
    if (!Array.isArray(errors)) return null; 
    const fieldError = errors.find((err) => err.path === field);
    return fieldError?.msg || null;
  };
  

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        if (type === 'add') {
          handleAddBarcode()
        } else {
          handleUpdateBarcode();
        }
      }
    };

    window.addEventListener("keypress", handleKeyPress);

    return () => {
      window.removeEventListener("keypress", handleKeyPress);
    };
  }, [inputValues]);

  return (
    <Box>
      <Heading
        back={true}
        label={type === "add" ? "Add Ticket" : "Edit Ticket"}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}
      >
        <Box width={{ md: "50%", xs: "100%" }}>
          <TextInput
            bgColor={"#f9f9f9"}
            label={"Name"}
            type={"default"}
            placeholder={"Enter Name"}
            value={inputValues.name}
            onChange={(e) => {
              const newValue = e.target.value;
              setInputValues({
                ...inputValues,
                name: newValue,
              });

              setErrors((prevErrors) =>
                prevErrors.filter((err) => err.path !== "name")
              );
              setGeneralError(""); 
            }}
          />

          {getErrorMessage("name") && (
            <Box color="red" mb={2}>
              {getErrorMessage("name")}
            </Box>
          )}

          {generalError && (
            <Box color="red" mb={2}>
              {generalError}
            </Box>
          )}


          <CustomButton
            cursor="pointer"
            disabled={loading}
            onClick={type === "add" ? handleAddBarcode : handleUpdateBarcode}
          >
            {loading ? <CircularProgress size={25} sx={{ color: "white" }} /> : type === "add" ? "Add Ticket" : "Update"}
          </CustomButton>
        </Box>
      </Box>
    </Box>
  );
}

export default TicketCreation;
